import React, { useRef,useEffect } from "react";
import { useIntl } from "react-intl";

import { Form, Input } from 'Components';

import SeverityOptions from 'Modules/alerts/common/components/SeverityOptions';
import * as components from './components'
import { useSelector } from "react-redux";

const extractTriggersRaw = (triggers) => {
    if (!triggers || !Array.isArray(triggers)) return undefined;
    
    const uniqueMap = new Map();
    
    triggers.forEach((item) => {
        const entity = item?.entity ?? item;
        const id = entity?.id;
        
        if (id !== undefined && id !== null && !uniqueMap.has(String(id))) {
            uniqueMap.set(String(id), {
                id: typeof id === 'string' ? parseInt(id, 10) : id,
                label: entity?.label,
                name: entity?.name || item?.entity?.name || "Landmark"
            });
        }
    });
    
    return Array.from(uniqueMap.values());
};

const Step1 = (props) => {

    const { currentAlert, value, onChange, formRef, nextStep, setCurrentAlert } = props
    const { messages } = useIntl()
    const internalFormRef = useRef()
    const CustomControl = currentAlert?.customControl && components[currentAlert?.customControl];
    const { alertTypesSupported } = useSelector((state) => state.alertsWizardRedux);

    useEffect(() => {
        if (alertTypesSupported?.length) {
            const codeAlert = CustomControl ? value.config?.code : currentAlert?.code
            const alertData = alertTypesSupported.find(x => x?.code == codeAlert)
            setCurrentAlert({...currentAlert, unitVersionIds: alertData?.unitVersionIds, conditions: alertData?.conditions})
        }
    }, [alertTypesSupported])

    useEffect(() => {
        if (value.triggers?.length > 0 && !value.triggersRaw) {
            const triggersRaw = extractTriggersRaw(value.triggers);
            if (triggersRaw?.length > 0) {
                onChange({
                    ...value,
                    triggersRaw
                });
            }
        }
    }, [value.triggers])

    return (
        <Form ref={formRef}
            noSubmit
            onValidSubmit={() => {
                nextStep()
            }}
            onSubmit={() => {
                return internalFormRef.current?.submit() == undefined ? true : internalFormRef.current?.submit();
            }}
        >
            <Input
                id='enterLabel'
                type='text'
                label={messages['alertsNewAlert_enterLabel']}
                placeholder={messages['alertsNewAlert_placeholderEnterLabel']}
                onChange={(name) => onChange({ ...value, name: name })}
                requiredMessage={messages['required_field']}
                min={1}
                value={value.name}
                maxLength={50}
                requiredMin
                autoFocus
                required
            />
            <SeverityOptions
                label={messages['alertsNewAlert_SetSeverity']}
                onChange={(newSeverity) => onChange({ ...value, severity: newSeverity })}
                selectedButtons={[{ id: value.severity }]}
                messages={messages}
            />
            {
                CustomControl &&
                <CustomControl formRef={internalFormRef} currentAlert={currentAlert} setCurrentAlert={setCurrentAlert} value={value.config} triggers={value.triggers} triggersRaw={value.triggersRaw}
                    onChange={(newConfig, triggersRaw) => {
                        onChange(
                            {
                                ...value,
                                config: newConfig,
                                triggersRaw: triggersRaw
                            }
                        )
                    }}
                />
            }
        </Form>
    )
}

export default Step1;
